import { html } from "../../helpers/html-template.js";
import { validate } from "../../helpers/validate.js";
import {
  attributesStepsSchema
} from "./attributes.js";
import { EditorClasses } from "../../styles.js";
const scalarStep = {
  name: "scalar-step",
  tagName: "scalar-step",
  tiptapName: "steps",
  attributeTransform: (_, attrs) => {
    return {
      id: String(attrs.id),
      title: String(attrs.title ?? ""),
      interactivity: "interactivity" in attrs ? String(attrs.interactivity) : void 0
    };
  },
  render: async (props) => {
    const interactive = !(props.interactivity?.toLowerCase() === "none");
    const detailsOrDiv = interactive ? "details" : "div";
    const summaryOrDiv = interactive ? "summary" : "div";
    const classNames = [EditorClasses.Step].join(" ");
    return html`
    <${detailsOrDiv}
      class="${classNames}"
      open
      role="listitem">
      <${summaryOrDiv} class="${EditorClasses.Editor}__step-summary">
        <div class="${EditorClasses.Editor}__step-marker-container">
          <div class="${EditorClasses.Editor}__step-marker"></div>
          <svg class="${EditorClasses.Editor}__step-marker-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256"><path d="M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"></path></svg>
        </div>
        <span class="${EditorClasses.Editor}__step-label" for="${EditorClasses.Editor}__steps-input-${props.id}">${props.title}</span>
      </${summaryOrDiv}>
      <div class="${EditorClasses.Editor}__step-content">
        <div
          class="guide-node-component ${EditorClasses.Editor}__paragraph">
          <ssg-children></ssg-children>
        </div>
      </div>
    </${detailsOrDiv}>
    `;
  }
};
const scalarSteps = {
  name: "scalar-steps",
  tagName: "scalar-steps",
  tiptapName: "steps",
  attributeTransform: (_content, props) => {
    const children = props.children ?? [];
    const transformed = {
      children: children.map((child) => {
        return {
          id: child.id ?? child.dataId,
          title: child.title ?? child.dataTitle
        };
      })
    };
    return validate(attributesStepsSchema, transformed);
  },
  render: async (_props) => {
    const classNames = [
      EditorClasses.Steps,
      `${EditorClasses.Editor}__steps-container`
    ].join(" ");
    return html`
<div class="${classNames}" role="list">
  <div class="${EditorClasses.Editor}__steps-content"><ssg-children></ssg-children></div>
</div>
`;
  }
};
export {
  scalarStep,
  scalarSteps
};
//# sourceMappingURL=index.js.map
